import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=3e66566c"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports